import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab'
import loginState from './loginState'

Vue.use(Vuex)

// 创建vuex的实例
export default new Vuex.Store({
	modules: {
		tab
	},
	state: {
	  isLoggedIn: false,
	  userId: null,
	  userInfo:{
		  avatar:''
	  },
	},
	mutations: {
	  login(state, userInfo) {
	    state.isLoggedIn = true;
	    state.userInfo = userInfo;
		state.userId = userInfo.userId
	  },
	  logout(state) {
	    state.isLoggedIn = false;
	    state.userId = null;
		state.userInfo={}
	  }
	},
	actions: {
	  login({ commit }, userId) {
	    // 执行登录操作，例如发送登录请求到后端验证
	    // 登录成功后调用 mutation 来更新登录状态
	    commit('login', userId);
	  },
	  logout({ commit }) {
	    // 执行退出登录操作，例如清除本地存储的登录信息
	    // 退出登录后调用 mutation 来更新登录状态
	    commit('logout');
	  }
	}
})
